// the id of the video a YouTube link points to (watch, shorts, embed or youtu.be), or null
export const youtubeId = (url) => {
    const match = String(url || '').trim().match(/^https?:\/\/(?:www\.|m\.)?(?:youtube\.com\/(?:watch\?(?:.*&)?v=|shorts\/|embed\/)|youtu\.be\/)([\w-]{11})/);
    return match ? match[1] : null;
};
